import {createSlice} from '@reduxjs/toolkit'
import {pagination} from '../../helpers'

const initialState = {
  filters: [],
  filterList: {},
  pagination,
  nameFilter: [],
  name: null,
}

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    filtersCreate: (state, action) => {
      const {pages, values} = action.payload
      const existingFilterIndex = state.filters.findIndex((filter) => filter.pages === pages)

      if (existingFilterIndex !== -1) {
        state.filters[existingFilterIndex] = {pages, values}
      } else {
        state.filters.push({pages, values})
      }
    },
    filtersGetAll: (state, action) => {
      const pages =
        typeof action.payload === 'object' && action.payload != null && 'pages' in action.payload
          ? action.payload.pages
          : action.payload
      const filterItem = state.filters.find((filter) => filter.pages === pages)
      state.filterList = filterItem && filterItem.values != null ? filterItem.values : {}
    },
    filtersDelete: (state, action) => {
      const pages =
        typeof action.payload === 'object' && action.payload != null && 'pages' in action.payload
          ? action.payload.pages
          : action.payload
      state.filters = state.filters.filter((filter) => filter.pages !== pages)
      state.filterList = {}
    },
    filtersSearchCreate: (state, action) => {
      const {pages, value} = action.payload
      const existingFilterIndex = state.nameFilter.findIndex((filter) => filter.pages === pages)

      if (existingFilterIndex !== -1) {
        state.nameFilter[existingFilterIndex] = {pages, value}
      } else {
        state.nameFilter.push({pages, value})
      }
    },
    filtersSearchGetAll: (state, action) => {
      const pages =
        typeof action.payload === 'object' && action.payload != null && 'pages' in action.payload
          ? action.payload.pages
          : action.payload
      const nameItem = state.nameFilter.find((filter) => filter.pages === pages)
      state.name = nameItem && nameItem.value != null ? nameItem.value : ''
    },
    resetFilters: () => initialState,
  },
})

export const {
  filtersCreate,
  filtersGetAll,
  filtersDelete,
  filtersSearchCreate,
  filtersSearchGetAll,
  resetFilters,
} = filtersSlice.actions

export const selectFilters = (state) => state.filters.filters
export const selectFilterList = (state) => state.filters.filterList
export const selectNameFilter = (state) => state.filters.nameFilter
export const selectFilterName = (state) => state.filters.name
export const selectFilterPagination = (state) => state.filters.pagination

export default filtersSlice.reducer
